export enum TrailTypeEnum {
	PRICE = 'trail_price',
	PERCENT = 'trail_percent',
}
